import { useQuery } from '@tanstack/react-query'
import SubscriptionsService from '@/libs/services/subscriptions'
import { getStaleTime, QUERY_TYPES } from '@/config/reactQuery'

/**
 * React Query hook for fetching current user subscriptions
 * @returns {Object} react-query result containing subscriptions data
 */
const SUBSCRIPTIONS_QUERY_KEY = ['subscriptions']

const fetchSubscriptions = async () => {
  const data = await SubscriptionsService.getSubscriptions()
  return data
}

const useSubscriptions = () =>
  useQuery({
    queryKey: SUBSCRIPTIONS_QUERY_KEY,
    queryFn: fetchSubscriptions,
    retry: false,
    staleTime: getStaleTime(QUERY_TYPES.SUBSCRIPTIONS),
  })

export default useSubscriptions
